import { useContext } from "react";
import { useQuery } from "react-query";
import * as api from "../services";
import AppContext from "../appContext";

const initMoodboard = [];

export default function useLocalMoodboard() {
  const {
    app: {
      client: { id: clientId },
      pauseQueries,
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const { data, isLoading, refetch } = useQuery(
    ["moodBoard", clientId, projectId, sessionId],
    () =>
      api.getLocalMoodboard({ clientId, projectId, sessionId }).then((data) => {
        return Array.isArray(data?.moodBoard) ? data?.moodBoard : initMoodboard;
      }),
    {
      placeholderData: () => initMoodboard,
      enabled: clientId !== -1 && !pauseQueries,
    }
  );

  return {
    localMoodboard: data,
    isLoadMoodboardLoading: isLoading,
    refetchLocalMoodboard: refetch,
  };
}
